import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: '100%',
  },
  section: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

export default function UserModal({
  open,
  user,
  vendors,
  onClose,
  onSave,
}) {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [formData, setFormData] = React.useState({
    email: '',
    admin: '0',
    vendor_id: '',
    newPassword: '',
  });

  React.useEffect(() => {
    if (user) {
      setFormData({
        email: user.email || '',
        admin: user.admin || '0',
        vendor_id: user.vendor_id || '',
        newPassword: '',
      });
    }
  }, [user]);

  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSave({
      ...user,
      ...formData,
    });
  };

  const handleSetPassword = () => {
      onResetPassword(user);
  };

  if (!user) return null;

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      aria-labelledby="user-modal"
      fullWidth={true}
      maxWidth="sm"
    >
      <form onSubmit={handleSubmit}>
        <DialogTitle id="user-modal">Rediger bruger</DialogTitle>
        <DialogContent>
          <Grid container direction="column" spacing={3}>
            <Grid item>
              <TextField
                fullWidth
                disabled
                id="email"
                name="email"
                label="Email"
                value={formData.email}
                helperText="Email kan ikke ændres"
              />
            </Grid>

            <Grid item>
              <FormControl className={classes.formControl}>
                <InputLabel id="admin-label">Admin status</InputLabel>
                <Select
                  labelId="admin-label"
                  id="admin"
                  name="admin"
                  value={formData.admin}
                  onChange={handleChange}
                >
                  <MenuItem value="0">Bruger</MenuItem>
                  <MenuItem value="1">Admin</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item>
              <Autocomplete
                id="vendor_id"
                options={[
                  { value: '', label: 'Ingen vendor' },
                  { value: 'admin', label: 'Admin' },
                  ...Object.entries(vendors)
                    .filter(([vendorId]) => vendorId !== 'admin')
                    .map(([vendorId, vendorAlias]) => ({
                      value: vendorId,
                      label: vendorAlias
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label))
                ]}
                getOptionLabel={(option) => option.label || ''}
                value={(() => {
                  if (!formData.vendor_id) return { value: '', label: 'Ingen vendor' };
                  if (formData.vendor_id === 'admin') return { value: 'admin', label: 'Admin' };
                  return { value: formData.vendor_id, label: vendors[formData.vendor_id] || formData.vendor_id };
                })()}
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: 'vendor_id',
                      value: newValue ? newValue.value : ''
                    }
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Vendor (Tenant)"
                    fullWidth
                  />
                )}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="default">
            Annuller
          </Button>
          <Button type="submit" color="primary" variant="contained">
            Gem ændringer
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
